import { Vue } from 'vue-property-decorator';
// import loader from '../../utils/loader';
import store from '../../../store';
import voucherOrderService from '../../../services/voucherOrder';
import { voucherMixin } from '../../../transformers/voucher';
import { voucherOrderMixin } from '../../../transformers/voucherOrder';
import tableMixin from '../../../Mixins/table';
import formMixin from '../../../Mixins/form';
import { debounce } from 'lodash';
import arrUtil from '../../../utils/arrayUtil';
import dateTime from '../../../utils/dateTime';
export default Vue.extend({
  store,
  mixins: [voucherMixin, voucherOrderMixin, tableMixin, formMixin],
  data: () => ({
    loadingVoucherOrder: false,
    panelVoucherOrder: [false],
    search: '',
    vouchersOrder: [],
    totalVouchersOrder: 0,
    vouchersOrderPagination: {
      sortBy: ['created_at'],
      sortDesc: [true],
    },
    voucherOrderHeaders: [
      {
        text: 'ID',
        align: 'center',
        value: 'id',
        sortable: false,
      },
      {
        text: 'Amount',
        align: 'center',
        value: 'amount',
        sortable: false,
      },
      {
        text: 'Quantity',
        align: 'center',
        value: 'quantity',
        sortable: false,
      },
      { text: 'Status', align: 'center', value: 'status', sortable: false },
      { text: 'Gateway', align: 'center', value: 'gateway', sortable: false },
      {
        text: 'Request By',
        align: 'center',
        value: 'by',
        sortable: false,
      },
      {
        text: 'Send To',
        align: 'center',
        value: 'to',
        sortable: false,
      },
      {
        text: 'Approved By',
        align: 'center',
        value: 'gateway',
        sortable: false,
      },
      {
        text: 'Created At',
        align: 'center',
        value: 'created_at',
        sortable: true,
      },
      {
        text: 'Action',
        align: 'center',
        value: 'id',
        sortable: false,
      },
    ],
  }),
  computed: {
    user() {
      return store.state.auth.user;
    },
    dateTime() {
      return dateTime;
    },
  },
  watch: {
    vouchersOrderPagination: {
      handler() {
        this.getVoucherOrderList().then((data) => {
          this.vouchersOrder = data.items;
          this.totalVouchersOrder = data.total;
        });
      },
      deep: true,
    },
    search() {
      this.getVoucherOrderList().then((data) => {
        this.vouchersOrder = data.items;
        this.totalVouchersOrder = data.total;
      });
    },
  },
  created() {},
  mounted() {},
  methods: {
    getVoucherOrderList() {
      this.loadingVoucherOrder = true;
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.vouchersOrderPagination;
        let query = {};
        if (itemsPerPage !== -1) {
          query.per_page = itemsPerPage;
          query.page = page;
        } else if (itemsPerPage == -1 && this.totalVouchersOrder) {
          query.per_page = this.totalVouchersOrder;
          query.page = page;
        }
        if (sortBy.length) {
          query.order = sortBy[0];
          query.sort = sortDesc[0] ? 'desc' : 'asc';
        } else {
          query.order = 'created_at';
          query.sort = 'desc';
        }
        if (this.search) query.q = this.search;

        voucherOrderService
          .all(query)
          .then((data) => {
            let items = data.data;
            const meta = data.meta;
            const total = meta.pagination.total;
            this.loadingVoucherOrder = false;
            resolve({
              items,
              total,
            });
          })
          .catch((err) => {
            this.loadingVoucherOrder = false;
            reject(err);
          });
      });
    },
    approvedVoucherOrder(one) {
      this.$root
        .$confirm(
          'Approved',
          `Are you sure for approved and create new Voucher <b>${this.formattedNumber(
            one.unit_value
          )}</b> Baht for <b>${one.quantity}</b>?`,
          {
            color: 'primary',
            submitText: 'Submit',
          }
        )
        .then(async (confirm) => {
          if (confirm) {
            let params = {
              status: 'approved',
            };
            let currentUser = JSON.parse(localStorage.getItem('id_token')).user;
            let approver_id = currentUser.id;
            if (approver_id) {
              params.approver_id = approver_id;
            }
            let id = await one.id;
            voucherOrderService.approved(id, params).then((data) => {
              this.$notify({
                title: 'Approved',
                text: 'Approved Voucher Order success !!',
                type: 'success',
              });
              this.vouchersOrder = arrUtil.searchByIdentityAndChangeAnyValue(
                this.vouchersOrder,
                { id: data.id },
                { status: 'approved' }
              );
            });
          }
        });
    },
    debounceInput: debounce(function (e) {
      this.search = e;
    }, 500),
  },
  components: {},
});
